import { Component, OnInit } from '@angular/core';
import { User } from '../../models/user.model';
import { UserService } from '../../services/services.index';
import { ModalUsuarioAdminService } from '../../components/modal-usuario-admin/modal-usuario-admin.service';

@Component({
  selector: 'app-usuarios-admin',
  templateUrl: './usuarios-admin.component.html',
  styles: []
})
export class UsuariosAdminComponent implements OnInit {

  users: User[];
  totalRegistros: number;

  loading: boolean = true;

  constructor( public _userService: UserService, public _modalUsuarioAdminService: ModalUsuarioAdminService ) { }

  ngOnInit() {
    this.cargarUsuariosAdmin();
    this._modalUsuarioAdminService.notification.subscribe(resp => {
      this.cargarUsuariosAdmin();
    });
  }

  cargarUsuariosAdmin() {
    this.loading = true;
    this._userService.getUsuariosAdmin().subscribe((resp: any) => {
      this.users = resp.users;
      this.totalRegistros = resp.total;
      this.loading = false;
    });
  }

  borrarUsuarioAdmin(user: User) {
    swal({
      title: 'Borrar Usuario',
      text: '¿Desea borrar el Usuario Administrador ' + user.name + ' ' + user.apellido + '?',
      icon: 'info',
      buttons: ['No', 'Si']
    })
    .then((willDelete) => {
      if (willDelete) {
        this.loading = true;
        this._userService.deleteUsuariosAdmin(user).subscribe((resp: any) => {
          this.loading = false;
          this.cargarUsuariosAdmin();
          swal('Usuario Borrado', 'El usuario ' + user.name + ' ' + user.apellido + 'fué borrado satisfactoriamente', 'success' );
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/usuarios-admin/usuarios-admin.component.ts